import { composeIO } from 'react-compose-io'
import { formularioRegraTransformacaoApIO } from './FormularioRegraTransformacaoApi.IO'
import { FormularioRegraTransformacaoApiView } from './FormularioRegraTransformacaoApi.View'

export const FormularioRegraTransformacaoApi = composeIO(FormularioRegraTransformacaoApiView, formularioRegraTransformacaoApIO)
